import React from "react";

const Search = ({ isOpen, onClose }) => {
  return (
    <div className={`search-wrap ${isOpen ? "active" : ""}`}>
      <div className="search-inner">
        <i
          className="fas fa-times search-close"
          onClick={onClose}
        ></i>

        <div className="search-cell">
          <form method="get">
            <div className="search-field-holder">
              <input
                type="search"
                className="main-search-input"
                placeholder="Search..."
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Search;
